import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c1944a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" 注意："),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("1、系統自动炸机检测可能存在一定误差，如系统未检测出炸机，客户可请自行按实际炸机日志选择并在故障报修页面修改炸机情况为【炸机】 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " 2、当前日志数据可能与实际作业存在时间差，可在完成飞行作 业后等待30分钟使设备完成云端数据同步。 ")
], -1))

import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'
import AppHeader from '@/components/Header.vue'
import FlyLogGroup from './components/flylog-group.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-log-select',
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const { malfunctionRepairState, changeSelectedLogGuid, changeBoomValue } =
  useMalfunctionRepairStore()
const sn = $route.query.sn as string
const guid = $route.query.guid as string
const active = ref(guid)

const list = computed(() => {
  return malfunctionRepairState.flylogsSnMap[sn] || []
})

function changeHandle(guid: string) {
  active.value = guid
}
function confirm() {
  const guid = active.value
  changeSelectedLogGuid(guid)
  const current = list.value.filter((item) => item.guid === guid)[0]
  current && changeBoomValue(current.isBoom)
  $router.go(-1)
}

onMounted(() => {
  // initLogsData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "选择故障日志" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(FlyLogGroup, {
        guid: _unref(guid),
        list: _unref(list),
        onChange: changeHandle
      }, null, 8, ["guid", "list"])
    ]),
    _createVNode(CommonFooterNextButton, {
      title: "确定",
      onClick: confirm
    })
  ], 64))
}
}

})